import {
  saveBookmark,
  deleteBookmark,
  getBookmarks,
} from './../api/services/bookmark';
export const bookmarkMixin = {
  data() {
    return {
      bookmarks: [],
      isProductAlreadyBookmarked: false,
      isSavingOrDeletingBookmark: false,
    };
  },
  async mounted() {
    if (localStorage.getItem('product_id')) {
      await this.saveDeleteBookmark();
    }
  },
  methods: {
    async getBookmarkList() {
      try {
        this.bookmarks = [];
        this.isProductAlreadyBookmarked = false;
        let { data } = this.$isLoggedIn
          ? await getBookmarks(this.$user.id)
          : [];
        this.bookmarks = data ? data.map((val) => val.product_id) : [];
        if (this.bookmarks.length) {
          let id = this.productId || +this.$route.params.id
          this.isProductAlreadyBookmarked = this.bookmarks.includes(
            id
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    bookmarkThisProduct(id) {
      if (this.$isLoggedIn) {
        this.saveDeleteBookmark(id);
      } else {
        this.$bvModal.show('login-form');
      }
    },
    async saveDeleteBookmark(id) {
      this.isSavingOrDeletingBookmark = true;
      try {
        if (!this.isProductAlreadyBookmarked) {
          await saveBookmark({
            buyer_id: this.$user.id,
            product_id: this.productId || +this.$route.params.id,
          });
        } else {
          await deleteBookmark(id);
        }
        this.getBookmarkList();
        this.isSavingOrDeletingBookmark = false;
        localStorage.removeItem('product_id');
      } catch (error) {
        console.log(error);
      }
    },
  },
};
